const cocoText = [
   `My wife told me it was over between us.`,

   `I didn't know what the hell I was going to do.`,

   `From that moment on, during the subsequent sever years or so, and counting, right up until this very day,
    my life has been a barrage of twists and turns, ups and downs, fantasized love affairs, confusion mutinies,
    shameful thoughts, excursions across the oceans of insecurities, desperate late-night ramblings, 
    conversations between only myself and four empty walls, my atomized self within the echoes of myself,
    lonesome walks veiled within the smog of the streets that licked my face constantly. 
    And yet, I still carry on.`,

    `We were living in Long Beach at the time, Pattie and I, in a comfortable one-bedroom apartment.`,

    `Every square foot was fully carpeted in brown shag. It was a long apartment, with a long living room
    that included the dining room. It had these five large windows spread out all around on each wall so wherever
    you looked the outside awaited.`,

    `I've always had a thing for lots of windows. And I loved those windows in particular
    because of all the sunlight they always let in all day long whenever the blinds
    were pulled back all the way.`,
    
    `The room was bright that day.`,

    `We could hear the traffic down below as we sat there having one of our last conversations together,
    her on an armchair and me on the couch, still in shock and becoming more afraid by the second as we peeled back
    the layers of our marriage that could no longer be ignored.`,

    `Where we lived was a lively neighborhood, plush with suburban landscapes and architectural design from an America that 
    still bled the brazen feel of the 1940's; rolling immaculate lawns, walls of tall, perfectly pine-green hedges separating some 
    of the buildings.`,

    'Every garden and every tree was always well manicured.',

];

export default cocoText;